<script>
import Profile from '@/pages/users/profile';
import UserAccountsTable from '@/pages/users/UserAccountsTable';
import PayrollReceiptsTable from '@/pages/users/PayrollReceiptsTable';
import SensitiveDataTab from '@/pages/users/SensitiveDataTab';
import AttendanceHistoryTab from '@/pages/users/AttendanceHistoryTab';
import { mapGetters } from 'vuex';
// import { checkPermission } from '@/helpers/acl';

export default {
    components: {
        Profile,
        UserAccountsTable,
        PayrollReceiptsTable,
        SensitiveDataTab,
        AttendanceHistoryTab,
        UserDocumentsTab: () => import('@/pages/users/UserDocumentsTab')
    },
    data() {
        return {
            activeTab: 1
        };
    },
    computed: {
        ...mapGetters({
            authUser: 'auth/user'
        }),
        canEdit() {
            // User viewing own profile can never edit. Only edit_users can edit other profiles.
            return false; // Always false for own profile view
        }
    }
};
</script>

<template>
    <div class="card card-settings">
        <div class="card-header card-header-tabs-custom">
            <ul class="nav nav-tabs nav-fill card-header-tabs tabs-rounded">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 1 }"
                        href="#"
                        @click.prevent="activeTab = 1"
                    >Información personal</a>
                </li>
                <li class="nav-item" v-can="'sensitive_data'">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 4 }"
                        href="#"
                        @click.prevent="activeTab = 4"
                    >Datos sensibles</a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 2 }"
                        href="#"
                        @click.prevent="activeTab = 2"
                    >Mis recibos de nómina</a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 3 }"
                        href="#"
                        @click.prevent="activeTab = 3"
                    >Mis cuentas</a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 5 }"
                        href="#"
                        @click.prevent="activeTab = 5"
                    >Historial de asistencia</a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === 6 }"
                        href="#"
                        @click.prevent="activeTab = 6"
                    >Archivo</a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <profile v-if="activeTab === 1" :userId="authUser.id"/>
            <payroll-receipts-table v-if="activeTab === 2" :userId="authUser.id" />
            <user-accounts-table v-if="activeTab === 3" :userId="authUser.id" />
            <sensitive-data-tab v-if="activeTab === 4" :userId="authUser.id" :canEdit="canEdit" />
            <attendance-history-tab v-if="activeTab === 5" :userId="authUser.id" />
            <user-documents-tab v-if="activeTab === 6" :userId="authUser.id" />
        </div>
    </div>
</template>

<style>
/* Card más moderna */
.card-settings {
  border: 0;
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  overflow: hidden; /* respeta el radio en el header */
}

/* Header sin borde feo */
.card-header-tabs-custom {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0;
}

/* Tabs estilo “barra inferior”, full width */
.tabs-rounded {
  border-bottom: 0;
}

.tabs-rounded .nav-link {
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  padding: 1rem 1.5rem;
  color: #6b7280;          /* gris elegante */
  font-weight: 500;
  font-size: 0.95rem;
}

.tabs-rounded .nav-link:hover {
  color: #0f766e;          /* teal oscuro */
}

.tabs-rounded .nav-link.active {
  color: #0f766e;
  border-bottom-color: #14b8a6;  /* línea turquesa */
  background-color: transparent;
}
</style>